<alaris-card>
	@if (tRows.length > 0 || tRows.length === 0 && state.isFiltersApplied) {
		<div class="table-management">
			<div class="left">
				<span class="total"> {{ totalTitle | translate }}: {{ total }} </span>
			</div>
			<div class="right">
				<button (click)="refresh()" alaris-button bType="outline" size="lg">
					<alaris-icon name="icon-refresh-clock-wise"></alaris-icon>
					{{ 'actions.refresh_page' | translate }}
				</button>
				<button (click)="export()" [disabled]="!!(exporting$ | async)" alaris-button bType="outline" size="lg"
					[disabled]="!this.user.allowed(['roles.edit'])">
					@if (exporting$ | async) {
						<alaris-spinner></alaris-spinner>
					} @else {
						<alaris-icon name="icon-export"></alaris-icon>
					}
					{{ 'gl.export' | translate }}
				</button>
				<button (click)="edit()" alaris-button bType="primary" size="lg" [disabled]="!this.user.allowed(['roles.edit'])">
					<alaris-icon class="in-primary" name="icon-plus"></alaris-icon>
					{{ 'users_roles.roles.create' | translate }}
				</button>
			</div>
		</div>
	}
	<div [alarisLoading]="loading$" alarisHorizontalOverflow class="content">
		@if (tRows.length === 0 && !state.isFiltersApplied) {
			<app-empty-table type="roles" [disabled]="!this.user.allowed(['roles.edit'])" (newRole)="edit()"></app-empty-table>
		} @else {
			<alaris-table [dblClickRowAction]="dblClickRowAction.bind(this)"
						  [dropDownRowActions]="dropDownRowActions"
						  [rowActions]="rowActions"
						  [tHeaders]="tHeaders"
						  [tRows]="tRows"
						  [templates]="{Author, Permissions}"
						  [resizable]="resizable"
						  alarisOverflowFader>
			</alaris-table>
		}
	</div>
	<div class="footer">
		<alaris-pagination (page)="_pageChange($event)"
						   [activePage]="activePage"
						   [class.without-table-bar]="selection !== null && selection.length === 0"
						   [hidden]="total === 0"
						   [pageSizeOptions]="pageSizeOptions"
						   [pageSize]="pageSize"
						   [total]="total"
						   class="pagination">
		</alaris-pagination>
	</div>
</alaris-card>

<ng-template #Author [alarisCellCtx]="tRows[0]" let-data="data" let-key="key">
	{{ data.Author?.Login }}
</ng-template>
<ng-template #Permissions [alarisCellCtx]="tRows[0]" let-data="data" let-key="key">
	<div class="choices">
		@for (permission of data.Permissions; track permission) {
		<alaris-tag>{{ permission }}</alaris-tag>
		}
	</div>
</ng-template>
